export default {
    it: "Italiano"
        /*,
            en: "English",
            es: "Español",
            pt: "Português",
            fr: "Français",*/
}